/** Helpers for setting an agent key up on a computer: which system, and the one command to run. */

import { APP_VERSION } from './version'

export type KeySystem = 'windows' | 'mac' | 'linux'

export function guessSystem(userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent): KeySystem {
  const agent = userAgent.toLowerCase()
  if (agent.includes('windows')) return 'windows'
  if (agent.includes('mac')) return 'mac'
  return 'linux'
}

/**
 * The command that saves the key on the person's computer, the same on every system (SEC2-04, docs/refactor/57): the
 * MCP server, from vephus.ai, writes it to a file only their user reads — not an environment variable, which every
 * program they run would see — and removes what the old setup left (the setx variable, the export line). The system
 * only changes where the terminal is opened.
 */
export function storeKeyCommand(_system: KeySystem, key: string): string {
  return `npx -y --package https://vephus.ai/downloads/vephus-mcp-${APP_VERSION}.tgz devpulse-mcp save-key ${key}`
}
